'use client'
import {useId, useState} from 'react'
import {useTranslation} from '../../../hooks/useTranslation'
import {Check} from 'lucide-react'
import {HelpTooltipButton} from '@fitro/customer-ui/HelpTooltipButton'
import {AcceptedPassGrid} from '@fitro/customer-ui/AcceptedPassCard'
import type { PublicPassOffer } from '../../../services/public-passes.service'
import { PublicPassOfferCard } from '../public-entry/PublicPassOfferCard'

export function AcceptedPassList({
    passes,
    usableIds,
}: {
    usableIds?: Set<string>
    passes: Array<Pick<PublicPassOffer, 'id' | 'name' | 'entriesTotal'> & Partial<PublicPassOffer>>
}) {
    return (
        <AcceptedPassGrid>
            {passes.map((offer) => (
                <li key={offer.id} className="min-w-0">
                    <PublicPassOfferCard offer={offer} variant="accepted" indicator={usableIds?.has(offer.id) ? <UsablePassIndicator /> : undefined} />
                </li>
            ))}
        </AcceptedPassGrid>
    )
}

function UsablePassIndicator() {
    const [open, setOpen] = useState(false)
    const id = useId()
    const {t} = useTranslation()
    const text = t('client.calendar.pass.ownedUsablePass')
    return <HelpTooltipButton ariaLabel={text} description={text}
        tooltipId={id} open={open} onToggle={() => setOpen(value => !value)}
        icon={<Check className="h-4 w-4" aria-hidden="true" />}
        buttonClassName="border-success-200 bg-success-50 text-success-700" />
}
